import React, { useContext } from 'react';
import type { LinkProps } from './Link.types';
import { StyledLink, StyledSpan } from './styles';
import { useUniversalComponents } from '../../../utils/useUniversalComponents';
export const Link = ({ children, to, ...props }: LinkProps) => {
  const fixScroll = () => {
    document.body.style.overflow = 'auto';
  };

  const { Link, isUsingNext } = useUniversalComponents();

  return (
    <Link
      href={to}
      onClick={fixScroll}
      style={{ textDecoration: 'none' }}>
      {isUsingNext ? (
        <StyledLink {...props}>{children}</StyledLink>
      ) : (
        <StyledSpan {...props}>{children}</StyledSpan>
      )}
    </Link>
  );
};
